export default "__VITE_ASSET__IXe$EJ91__"